import React, { Component } from "react";
import { Grid, Table, Form, Button, Icon } from "tabler-react";
import { Crud_Catalogos } from '../../../../herramientas/Crud_Catalogos';
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import { MapContainer, TileLayer } from "react-leaflet";

import axios from 'axios';
import { api_raiz } from '../../../../config/config';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ArcGISMap from './ArcGISMap';

class BitacoraPdf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      trackPoints: [],
      incidencias: [],
      distancia: 0,
      patio: {},
      movlogs: {},
      tiempoEntrePulsos: 0,
      detencionesCalculadas: [],
      imagesMovGps: [],
      loading: true,
      generatingPdf: false
    };

    this.tiempoRuta = 0;
    this.estadia = 0;
    this.avgLat = 0;
    this.avgLon = 0;
    this.coordenadas = [];
    this.distanciaCalculada = 0;

    this.componentRef = React.createRef();
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    const { Movimiento } = this.props;
    
    try {
      // Cargar datos en paralelo
      const [trackPoints, distancia, patio, incidencias, movlogs] = await Promise.all([
        this.loadTrackPoints(Movimiento.id),
        this.loadDistancia(Movimiento.id),
        this.loadPatio(Movimiento.id),
        this.loadIncidencias(Movimiento.id),
        this.loadMovlogs(Movimiento.id)
      ]);

      this.setState({
        trackPoints,
        distancia,
        patio,
        incidencias,
        movlogs,
        loading: false
      });

      // Cargar imágenes después de obtener los datos principales
      await this.loadImages(Movimiento.id);
      
    } catch (error) {
      console.error("Error cargando datos:", error);
      this.setState({ loading: false });
    }
  }

  async loadTrackPoints(movimientoId) {
    const { Movimiento } = this.props;
    try {
      let trackPoints = await Crud_Catalogos(`navieraMovimientos/tracks/${movimientoId}`, "", "get", "", [], "", "", "", []);
      
      // Si no hay suficientes puntos, intentar con esFull
      if (trackPoints && trackPoints.length < 3 && this.state.patio?.esFull) {
        trackPoints = await Crud_Catalogos(`navieraMovimientos/tracks/${this.state.patio.esFull}`, "", "get", "", [], "", "", "", []);
      }


      if(Movimiento.idMovimientoTipo.id===1) {
                           console.log("importamiento 2");

            if (trackPoints && trackPoints.length > 0 && Movimiento.salidaClienteLleno && Movimiento.arriboTerminalCargado) {
              const salidaClienteLlenoLocal = new Date(Movimiento.salidaClienteLleno);
              const arriboTerminalCargadoLocal = new Date(Movimiento.arriboTerminalCargado);
              const salidaClienteLlenoUTC = new Date(salidaClienteLlenoLocal.getTime() );
              const arriboTerminalCargadoUTC = new Date(arriboTerminalCargadoLocal.getTime() );
              trackPoints = trackPoints.filter(point => {
                if (!point.utc) return false;
                const pointDate = new Date(point.utc);
                return pointDate >= salidaClienteLlenoUTC && pointDate <= arriboTerminalCargadoUTC;
              });
            }
            return trackPoints || [];
      }


      if( Movimiento.idMovimientoTipo.id===2) {
         if ( trackPoints &&  trackPoints.length > 0 && Movimiento.salidaClienteLleno  && Movimiento.arriboTerminalCargado) {
                   console.log("exportamiento 2");
           const inicioRutaLocal = new Date(Movimiento.salidaClienteLleno);
           const salidaTerminalLlenoLocal = new Date(Movimiento.arriboTerminalCargado);
           const inicioRutaUTC = new Date(inicioRutaLocal.getTime() );
           const salidaTerminalLlenoUTC = new Date(salidaTerminalLlenoLocal.getTime() );
           trackPoints = trackPoints.filter(point => {
            if (!point.utc) return false;
             const pointDate = new Date(point.utc);        
             return pointDate >= inicioRutaUTC && pointDate <= salidaTerminalLlenoUTC;
             
           });
         }


         return trackPoints || [];
      }


      
      // return trackPoints || [];
    } catch (error) {
      console.error("Error cargando track points:", error);
      return [];
    }
  }

  async loadDistancia(movimientoId) {
    try {
      return await Crud_Catalogos(`distanciaRecorridaView/distanciaRecorrida/${movimientoId}`, "", "get", "", [], "", "", "", []);
    } catch (error) {
      console.error("Error cargando distancia:", error);
      return 0;
    }
  }

  async loadPatio(movimientoId) {
    try {
      return await Crud_Catalogos(`movimientosPatio/idMovimiento/${movimientoId}`, "", "get", "", [], "", "", "", []);
    } catch (error) {
      console.error("Error cargando patio:", error);
      return {};
    }
  }

  async loadIncidencias(movimientoId) {
    try {
      return await Crud_Catalogos(`movimientoIncidencias/movimiento/${movimientoId}`, "", "get", "", [], "", "", "", []);
    } catch (error) {
      console.error("Error cargando incidencias:", error);
      return [];
    }
  }

  async loadMovlogs(movimientoId) {
    try {
      return await Crud_Catalogos(`navieraMovimientos/${movimientoId}`, "", "get", "", [], "", "", "", []);
    } catch (error) {
      console.error("Error cargando movlogs:", error);
      return {};
    }
  }

  async loadImages(movimientoId) {
    try {
      const instance = axios.create({
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('tok'),
        },
      });

      const response = await instance.get(`${api_raiz}movimientoGps/movimiento/${movimientoId}`);
      
      if (response.data && response.data.length > 0) {
        const movGpsId = response.data[0].id;
        const imagesResponse = await instance.get(`${api_raiz}getImagesMovGps/${movGpsId}/asignacion`);
        
        if (imagesResponse.data && imagesResponse.data.length > 0) {
          this.setState({ imagesMovGps: imagesResponse.data });
        }
      }
    } catch (error) {
      console.error("Error cargando imágenes:", error);
    }
  }

  // Función para generar el PDF
  async generatePDF() {
    const { Movimiento } = this.props;
    
    this.setState({ generatingPdf: true });
    
    try {
      const input = this.componentRef.current;
      
      // Configuración para html2canvas
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: document.documentElement.offsetWidth,
        scrollY: -window.scrollY,
        // Importante para capturar mapas
        onclone: (clonedDoc) => {
          // Asegurar que los elementos del mapa sean visibles
          const maps = clonedDoc.getElementsByClassName('leaflet-container');
          for (let map of maps) {
            map.style.zIndex = '1';
          }
        }
      });

      // Crear PDF
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 10;
      
      // Calcular cuántas páginas necesitamos
      const pageHeight = imgHeight * ratio;
      const totalPages = 1;//Math.ceil(pageHeight / (pdfHeight - 20));
      
      // Agregar las páginas necesarias
      for (let page = 0; page < totalPages; page++) {
        if (page > 0) {
          pdf.addPage();
        }
        
        const yOffset = -(page * (pdfHeight - 20) / ratio);
        
        pdf.addImage(
          imgData,
          'PNG',
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio,
          undefined,
          'FAST',
          0,
          yOffset
        );
      }
      
      // Guardar el PDF
      const fileName = `Bitacora_${Movimiento.booking || Movimiento.id}_${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(fileName);
      
    } catch (error) {
      console.error("Error generando PDF:", error);
      alert("Error al generar el PDF. Por favor, intente nuevamente.");
    } finally {
      this.setState({ generatingPdf: false });
    }
  }

  // Función para calcular la distancia entre dos puntos usando Haversine
  calcularDistanciaEntrePuntos(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radio de la Tierra en km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2); 
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    return R * c;
  }

  deg2rad(deg) {
    return deg * (Math.PI/180);
  }

  calcularDetenciones(coordenadas, tiempoEntrePulsos) {
    if (!coordenadas || coordenadas.length < 2 || !tiempoEntrePulsos) {
      return [];
    }

    const detenciones = [];
    const UMBRAL_DISTANCIA = 0.05; // 50 metros
    const UMBRAL_TIEMPO_MINUTOS = 15;
    const PULSOS_PARA_DETENCION = Math.ceil(UMBRAL_TIEMPO_MINUTOS / tiempoEntrePulsos);

    let contadorPulsosSinMovimiento = 0;
    let inicioDetencionIndex = null;

    for (let i = 1; i < coordenadas.length; i++) {
      const puntoActual = coordenadas[i];
      const puntoAnterior = coordenadas[i - 1];

      const distancia = this.calcularDistanciaEntrePuntos(
        puntoActual[0], puntoActual[1],
        puntoAnterior[0], puntoAnterior[1]
      );

      if (distancia < UMBRAL_DISTANCIA) {
        if (contadorPulsosSinMovimiento === 0) {
          inicioDetencionIndex = i - 1;
        }
        contadorPulsosSinMovimiento++;
      } else {
        if (contadorPulsosSinMovimiento >= PULSOS_PARA_DETENCION && inicioDetencionIndex !== null) {
          const finDetencionIndex = i - 1;
          const duracion = contadorPulsosSinMovimiento * tiempoEntrePulsos;

          detenciones.push({
            inicioPulso: inicioDetencionIndex,
            finPulso: finDetencionIndex,
            inicio: inicioDetencionIndex * tiempoEntrePulsos,
            fin: finDetencionIndex * tiempoEntrePulsos,
            duracion: duracion,
            latitud: coordenadas[inicioDetencionIndex][0],
            longitud: coordenadas[inicioDetencionIndex][1]
          });
        }

        contadorPulsosSinMovimiento = 0;
        inicioDetencionIndex = null;
      }
    }

    // Verificar detención al final
    if (contadorPulsosSinMovimiento >= PULSOS_PARA_DETENCION && inicioDetencionIndex !== null) {
      const finDetencionIndex = coordenadas.length - 1;
      const duracion = contadorPulsosSinMovimiento * tiempoEntrePulsos;

      detenciones.push({
        inicioPulso: inicioDetencionIndex,
        finPulso: finDetencionIndex,
        inicio: inicioDetencionIndex * tiempoEntrePulsos,
        fin: finDetencionIndex * tiempoEntrePulsos,
        duracion: duracion,
        latitud: coordenadas[inicioDetencionIndex][0],
        longitud: coordenadas[inicioDetencionIndex][1]
      });
    }

    return detenciones;
  }

  calcularTiempos() {
    const { Movimiento } = this.props;
    const tipoMovimiento = Movimiento.idMovimientoTipo.id;

    let tiempoRuta = 0;
    let estadia = 0;

    if (tipoMovimiento === 1) {
      const inicioRuta = new Date(Movimiento.inicioRuta);
      const arriboClienteLleno = new Date(Movimiento.arriboClienteLleno);
      const salidaClienteVacio = new Date(Movimiento.salidaClienteVacio);
      
      tiempoRuta = arriboClienteLleno - inicioRuta;
      estadia = salidaClienteVacio - arriboClienteLleno;
    } else if (tipoMovimiento === 2) {
      const arriboClienteVacio = new Date(Movimiento.arriboClienteVacio);
      const salidaClienteLleno = new Date(Movimiento.salidaClienteLleno);
      const arriboTerminalCargado = new Date(Movimiento.arriboTerminalCargado);
      
      estadia = salidaClienteLleno - arriboClienteVacio;
      tiempoRuta = Math.abs(salidaClienteLleno - arriboTerminalCargado);
    }

    return {
      tiempoRuta: Math.abs(tiempoRuta) > 1600000000000 ? 0 : (tiempoRuta / (1000 * 3600)).toFixed(2),
      estadia: Math.abs(estadia) > 1600000000000 ? 0 : (estadia / (1000 * 3600)).toFixed(2)
    };
  }

  procesarCoordenadas() {
    const coordenadas = [];
    let avgLat = 0;
    let avgLon = 0;

    this.state.trackPoints.forEach(punto => {
      if (punto.position && punto.position.latitude && punto.position.longitude) {
        avgLat += punto.position.latitude;
        avgLon += punto.position.longitude;
        coordenadas.push([punto.position.latitude, punto.position.longitude]);
      }
    });

    if (coordenadas.length > 0) {
      avgLat = avgLat / coordenadas.length;
      avgLon = avgLon / coordenadas.length;
    }

    return { coordenadas, avgLat, avgLon };
  }

  calcularDistanciaTotal(coordenadas) {
    let distanciaTotal = 0;
    
    for (let i = 0; i < coordenadas.length - 1; i++) {
      const [lat1, lon1] = coordenadas[i];
      const [lat2, lon2] = coordenadas[i + 1];
      
      if (lat1 && lon1 && lat2 && lon2) {
        distanciaTotal += this.calcularDistanciaEntrePuntos(lat1, lon1, lat2, lon2);
      }
    }
    
    return distanciaTotal;
  }

  formatearFecha(fecha) {
    const date = new Date(fecha);
    return `${date.getDate()} de ${date.toLocaleDateString('es-ES', { month: 'long' })}`;
  }

  renderHeader() {
    const hoy = new Date();
    return (
      <div>
        <img src="images/head.png" alt="Header" />
        <br /><br /><br />
        <Grid.Col>
          <h2 align="right">
            Ciudad de México a {this.formatearFecha(hoy)} de {hoy.getFullYear()}&nbsp;&nbsp;&nbsp;&nbsp;
          </h2>
          <br /><br />
        </Grid.Col>
      </div>
    );
  }

  renderInfoBasica() {
    const { Movimiento } = this.props;
    const { patio } = this.state;

    return (
      <div>
        &nbsp;&nbsp;&nbsp; Servicio:<b>{Movimiento.idCliente.nombreCorto}</b>
        <p>&nbsp;&nbsp;&nbsp; Sky Angel </p>
        <br /><br />
        
        <table className="table">
          <tbody>
            <tr>
              <td><b>Solicitó:</b>&nbsp;&nbsp;{Movimiento.idTransportista.contactoNombre || "No Disponible"}</td>
              <td><b>Solicitado:</b>&nbsp;&nbsp;{this.formatearFecha(Movimiento.creationDate)}</td>
              <td><b>Colocado:</b>&nbsp;&nbsp;{this.formatearFecha(Movimiento.citaProgramada)}</td>
            </tr>
          </tbody>
        </table>

        <table className="table">
          <tbody>
            <tr>
              <td>
                <br/><br/><br/>
                <table className="table">
                  <tbody>
                    <tr>
                      <td><b>Transporte:</b></td>
                      <td>{Movimiento.idTransportista.nombre}</td>
                    </tr>
                    <tr>
                      <td><b>Booking:</b></td>
                      <td>{Movimiento.booking}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              
              <td>
                <br/><br/><br/>
                <table className="table">
                  <tbody>
                    <tr>
                      <td><b>Unidad:</b> {patio.tractorPlaca}</td>
                    </tr>
                    <tr>
                      <td><b>Remolque:</b> {patio.remolquePlaca}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderDetallesMovimiento(tiempos, coordenadas, distanciaTotal) {
    const { Movimiento } = this.props;
    const { movlogs, detencionesCalculadas, distancia } = this.state;

    return (
      <table className="table">
        <tbody>
          <tr>
            <td><b>Origen:</b></td>
            <td>{Movimiento.idCorredor.nombre}</td>
            <td><b>Destino:</b></td>
            <td>{Movimiento.destino}</td>
          </tr>

          {/* Campos específicos para exportaciones */}
          {Movimiento.idMovimientoTipo.id === 1 && (
            <>
              <tr>
                <td><b>Inicio de Ruta:</b></td>
                <td>{Movimiento.inicioRuta}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td><b>Salida de terminal con contenedor cargado:</b></td>
                <td>{movlogs.salidaTerminalLleno}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td><b>Arribo a Cliente:</b></td>
                <td>{movlogs.arriboClienteLleno}</td>
                <td></td>
                <td></td>
              </tr>
            </>
          )}

          {/* Campos específicos para importaciones */}
          {Movimiento.idMovimientoTipo.id === 2 && (
            <tr>
              <td><b>Salida de dirección de entrega:</b></td>
              <td>{Movimiento.salidaClienteLleno}</td>
              <td><b>Ingreso a terminal:</b></td>
              <td>{Movimiento.arriboTerminalCargado}</td>
            </tr>
          )}

          <tr>
            <td><b>Tiempo total de ruta:</b> {tiempos.tiempoRuta} hrs</td>
            <td></td>
            <td><b>Estadía en cliente:</b> {tiempos.estadia} hrs</td>
            <td></td>
          </tr>

          <tr>
            <td><b>Distancia recorrida:</b></td>
            <td>
              {coordenadas.length > 1 ? 
                `${distanciaTotal.toFixed(2)} km` : 
                (distancia === 0 ? "No disponible" : `${(distancia/1000)} km`)}
            </td>
          </tr>

          <tr>
            <td><b>Detenciones calculadas:</b></td>
            <td>{detencionesCalculadas?.length || 0}</td>
          </tr>

          <tr>
            <td><b>Evidencia de colocación:</b></td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderTablaDetenciones() {
    const { detencionesCalculadas } = this.state;
    
    if (!detencionesCalculadas || detencionesCalculadas.length === 0) {
      return null;
    }

    return (
      <div>
        <h4 style={{ marginTop: "20px", marginBottom: "10px" }}>Detenciones de Ruta</h4>
        <table className="table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Inicio (min)</th>
              <th>Fin (min)</th>
              <th>Duración (min)</th>
              <th>Ubicación</th>
            </tr>
          </thead>
          <tbody>
            {detencionesCalculadas.map((detencion, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{detencion.inicio.toFixed(2)}</td>
                <td>{detencion.fin.toFixed(2)}</td>
                <td>{detencion.duracion.toFixed(2)}</td>
                <td>
                  Lat: {detencion.latitud.toFixed(5)}, Lon: {detencion.longitud.toFixed(5)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderTablaIncidencias() {
    const { incidencias } = this.state;
    
    if (!incidencias || incidencias.length === 0) {
      return null;
    }

    const incidenciasFiltradas = incidencias
    .filter(incidencia => ![2,3,7,8,9,67,35, 11, 12,13, 14,16,860].includes(incidencia.incidencia.incidenciaTipo.id))
      // .filter(incidencia => incidencia.incidencia.incidenciaTipo.id !== 7 && incidencia.incidencia.incidenciaTipo.id !== 11 && incidencia.incidencia.incidenciaTipo.id !== 14)
      .sort((a, b) => new Date(a.fechaCreado) - new Date(b.fechaCreado));

    if (incidenciasFiltradas.length === 0) {
      return null;
    }

    return (
      <div>
        <h4 style={{ marginTop: "20px", marginBottom: "10px" }}>Incidencias</h4>
        <table className="table">
          <thead>
            <tr>
              <th>No.</th>  
              <th>Fecha</th>
              <th>Nombre</th>
              <th>Ubicación</th>
            </tr>
          </thead>
          <tbody>
            {incidenciasFiltradas.map((incidencia, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{new Date(incidencia.fechaCreado).toLocaleString()}</td>
                {/* <td>{incidencia.incidencia.incidenciaTipo.nombre || "Sin descripción"}</td> */}
                <td>{incidencia.incidencia.nombre || "Sin descripción"}</td>
                <td>
                  {incidencia.latitud && incidencia.longitud ? 
                    `Lat: ${incidencia.latitud.toFixed(5)}, Lon: ${incidencia.longitud.toFixed(5)}` : 
                    "No disponible"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderMapaYEvidencia(coordenadas, avgLat, avgLon) {
    const { trackPoints, imagesMovGps } = this.state;

    return (
      <table className="table">
        <tbody>
          <tr>
            <td>
              <br />
              <h4>Evidencia de colocación:</h4>
              
              {/* Imágenes */}
              {imagesMovGps && imagesMovGps.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '100%' }}>
                  {imagesMovGps.map((image, index) => (
                    <div 
                      key={index} 
                      style={{ 
                        width: '33%', 
                        padding: '5px',
                        marginBottom: (index + 1) % 3 === 0 ? '20px' : '0'
                      }}
                    >
                      <img
                        src={`data:image/png;base64,${image}`}
                        style={{
                          width: '100%',
                          height: '200px',
                          objectFit: 'contain',
                        }}
                        alt={`Evidencia ${index + 1}`}
                      />
                    </div>
                  ))}
                </div>
              )}
            </td>
          </tr>
          
          {/* Mapa */}
          <tr>
            <td>
              <br />
              <h4>Mapa de ruta:</h4>
              {this.state.trackPoints.length ? (
                <div style={{ height: "400px", width: "70%" }}>
                  <ArcGISMap trackPoints={this.state.trackPoints} />
                </div>
              ) : null}
            </td>      
          </tr>
        </tbody>
      </table>
    );
  }

  renderFooter() {
    return (
      <div className="footer2">
        <h5 align="center">Río Danubio 87, Colonica Cuahutemoc, Delegación Cuahutémoc. C.P. 06500, Ciudad de México</h5>
        <h5 align="center">Skyangel México•EUA•Centroamérica</h5>
        <h5 align="center">52 76 76 70 | 01 800 750 54 63</h5>
      </div>
    );
  }

  render() {
    const { loading, generatingPdf } = this.state;

    if (loading) {
      return <div>Cargando...</div>;
    }

    // Procesar datos
    const tiempos = this.calcularTiempos();
    const { coordenadas, avgLat, avgLon } = this.procesarCoordenadas();
    const distanciaTotal = this.calcularDistanciaTotal(coordenadas);

    // Calcular detenciones si hay coordenadas
    if (coordenadas.length > 1 && parseFloat(tiempos.tiempoRuta) > 0) {
      const tiempoEntrePulsos = ((parseFloat(tiempos.tiempoRuta) * 60) / (coordenadas.length - 1)).toFixed(2);
      const detencionesCalculadas = this.calcularDetenciones(coordenadas, parseFloat(tiempoEntrePulsos));
      
      if (this.state.tiempoEntrePulsos !== tiempoEntrePulsos || 
          JSON.stringify(this.state.detencionesCalculadas) !== JSON.stringify(detencionesCalculadas)) {
        this.setState({ 
          tiempoEntrePulsos: tiempoEntrePulsos,
          detencionesCalculadas: detencionesCalculadas
        });
      }
    }

    return (
      <div style={{ marginLeft: '52px', marginRight: '83px' }}>
        {/* Botón de exportación PDF */}
        <div style={{ 
          position: 'fixed', 
          bottom: '20px', 
          left: '20px', 
          zIndex: 1000,
          backgroundColor: 'white',
          padding: '10px',
          borderRadius: '5px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <Button 
            color="primary"
            size="md"
            icon={generatingPdf ? undefined : "download"}
            disabled={generatingPdf}
            onClick={() => this.generatePDF()}
          >
            {generatingPdf ? 'Generando PDF...' : 'Exportar a PDF'}
          </Button>
        </div>

        <Grid.Row>
          <div>
            <div ref={this.componentRef}>
              {this.renderHeader()}
              <div>
                {this.renderInfoBasica()}
                {this.renderDetallesMovimiento(tiempos, coordenadas, distanciaTotal)}
                {this.renderTablaDetenciones()}
                {this.renderTablaIncidencias()}
                {this.renderMapaYEvidencia(coordenadas, avgLat, avgLon)}
              </div>
              {this.renderFooter()}
            </div>
          </div>
        </Grid.Row>
      </div>
    );
  }
}

export default BitacoraPdf;